(() => {
  const buttons = document.querySelectorAll('#scrolly .ed-num');
  const stepEl = document.getElementById('stStep');
  const titleEl = document.getElementById('stTitle');
  const textEl = document.getElementById('stText');
  const chipsEl = document.getElementById('stChips');
  const ghost = document.getElementById('stGhost');
  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      buttons.forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');
      if (stepEl) stepEl.textContent = btn.dataset.kicker || '';
      if (titleEl) titleEl.textContent = btn.dataset.title || '';
      if (textEl) textEl.textContent = btn.dataset.text || '';
      if (ghost) ghost.textContent = btn.textContent.trim();
      if (chipsEl) {
        while (chipsEl.firstChild) chipsEl.removeChild(chipsEl.firstChild);
        (btn.dataset.chips || '').split(',').forEach((c) => {
          const s = c.trim();
          if (!s) return;
          const span = document.createElement('span');
          span.className = 'ed-datum';
          span.textContent = s;
          chipsEl.appendChild(span);
        });
      }
    });
  });
  const legend = document.getElementById('specLegend');
  const num = document.getElementById('specNum');
  const cap = document.getElementById('specCap');
  legend?.querySelectorAll('button').forEach((b) => {
    b.addEventListener('click', () => {
      if (num) {
        while (num.firstChild) num.removeChild(num.firstChild);
        num.appendChild(document.createTextNode(b.dataset.nm || ''));
        const sup = document.createElement('sup');
        sup.textContent = 'nm';
        num.appendChild(sup);
      }
      if (cap) cap.textContent = b.dataset.cap || '';
      legend.querySelectorAll('button').forEach((x) => x.classList.remove('active'));
      b.classList.add('active');
    });
  });

  /* Defer 3.6MB science video until the scrolly is near viewport */
  const stageVideo = document.getElementById('stageVideo');
  const scrolly = document.getElementById('scrolly');
  if (stageVideo && stageVideo.dataset.src && scrolly && 'IntersectionObserver' in window) {
    const loadVid = () => {
      if (stageVideo.src) return;
      stageVideo.src = stageVideo.dataset.src;
      stageVideo.load();
      const play = () => stageVideo.play().catch(() => {});
      stageVideo.addEventListener('loadeddata', play, { once: true });
    };
    new IntersectionObserver(
      ([e], obs) => {
        if (e.isIntersecting) {
          loadVid();
          obs.disconnect();
        }
      },
      { rootMargin: '200px 0px' }
    ).observe(scrolly);
  } else if (stageVideo && stageVideo.dataset.src) {
    stageVideo.src = stageVideo.dataset.src;
    stageVideo.setAttribute('autoplay', '');
  }
})();
